import { SchemaTranslations } from './schema-translations';
import { ConsentsTranslations } from './consents-translations';
import { ApiTranslations } from '@app/core/_models/api-translations';

export class Translations {
  constructor(private translations: ApiTranslations) {}

  public getSchemaTranslations(): SchemaTranslations {
    return new SchemaTranslations(this.translations.member_properties || {});
  }

  public getConsentsTranslations(): ConsentsTranslations {
    return new ConsentsTranslations(this.translations.consents || {});
  }
}
